import { getUploadedImagePath } from '@nutastic/nutastic-react-app';

/**
 *
 * @param musicObjectList - object with references to music data
 * @param coverImage - image for the cover
 * @returns {{title: *, src: string, author: string, thumbnail: string}[]}
 */
const buildTracks = (musicObjectList, coverImage) => {
    return (musicObjectList || []).map(track => {
        const { title, field_2: audioFile, field_6: artistOverride } = track;
        return {
            title: title,
            src: getUploadedImagePath(audioFile),
            author: artistOverride || 'Quistar',
            thumbnail: getUploadedImagePath(coverImage)
        }
    })
};

export default buildTracks;
